import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-close',
  templateUrl: './close.component.html',
  styleUrls: ['./close.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class CloseComponent {
  @Output() closeEvent = new EventEmitter();
  @Output() closeMouseDown = new EventEmitter<Event>();

  closeEventHandler(event: Event) {
    this.closeEvent.emit(event);
  }

  closeMouseDownHandler(event: Event) {
    this.closeMouseDown.emit(event);
  }
}
